define('bindingHandlers/audio/waveform',[
    'lib/knockout',
    'lib/lodash4',
    'jquery',
    'lib/waveform'
], function (ko, _, $, Waveform) {
    'use strict';

    /**
     * Binding handler that renders a waveform from sound amplitude data
     * @param {Object[]} options.data - Array of Numbers describing amplitude, between 0 and 1
     *
     * # Optional Arguments
     * @param {String} [options.innerColor='transparent'] A string indicating inner color to user for the waveform
     * @param {String} [options.outerColor='#fff'] A string indicating outer color to user for the waveform
     *
     * Sample usage: waveform: {
     *                   data: [],
     *                   innerColor: '#333',
     *                   outerColor: 'transparent'
     *               }
     *
     */
    ko.bindingHandlers.waveform = {
        init: function (element, valueAccessor) {

            var waveformOptions = {
                canvas: element,
                data: [], // This will get filled in at update
                innerColor: valueAccessor().innerColor || 'transparent',
                outerColor: valueAccessor().outerColor || '#ffffff',
                interpolate: true
            };

            // This draws on the canvas as a side effect.
            var waveform = new Waveform(waveformOptions);
            ko.utils.domData.set(element, 'waveform', waveform);

            // Cleanup
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                ko.utils.domData.clear(element, 'waveform');
            });

        },
        update: function (element, valueAccessor) {
            var waveform = ko.utils.domData.get(element, 'waveform');

            if (waveform) {
                var mappedData = _.map(ko.unwrap(valueAccessor().data), function (value) {
                    return (Math.abs(value - 0.5) * 4) + 0.01;
                });

                waveform.update({
                    data: mappedData
                });
            }
        }
    };
});

